import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroupErrorMessageComponent, noWhitespaceValidator,
  PASSWORD_PATTERN, Utils, AlertIcon,AlertService } from 'lib-base';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { PasswordModule } from 'primeng/password';
import { PortalUsuarioService } from '../../../services/portalUsuario.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { firstValueFrom, forkJoin } from 'rxjs';
 import { RestablecerPasswordRequest } from '../../../shared/interfaces/seguridad';
import {ResponseAlert} from "../../../../../../lib-base/src/lib/shared";
import {LoadingPanelService} from "../../../../../../lib-base/src/lib";

@Component({
  selector: 'app-restablecer-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule,
    FormGroupErrorMessageComponent, PasswordModule, ButtonModule, DividerModule],
  templateUrl: './restablecer-password.component.html',
  styleUrl: './restablecer-password.component.scss'
})
export class RestablecerPasswordComponent implements OnInit {
  private _codigo !: string;
  isCodeValid: boolean = false;

  form !: FormGroup;

  translations: any = {};

  constructor(private _route: ActivatedRoute, private _pu: PortalUsuarioService, private _r: Router, private _fb: FormBuilder,
    private _t: TranslateService, private _ms: MessageService, private alertService:AlertService,
              private readonly loadingService:LoadingPanelService){
    this._codigo = this._route.snapshot.params['codigo'];
  }

  async ngOnInit() {
    this.translations = await firstValueFrom(forkJoin({
      codigoNoValido: this._t.get('components.app-restablecer-password.codigo-no-valido'),
      siguiente: this._t.get('form.button.siguiente'),
      contrasena: this._t.get('form.password.contrasena'),
      constasenaNoCoiniciden: this._t.get('form.password.constasena-no-coiniciden'),
      repitaContrasena: this._t.get('form.password.repita-contraseña'),
      alMenosUnaMinuscula: this._t.get('form.password.al-menos-una-minuscula'),
      alMenosUnaMayuscula: this._t.get('form.password.al-menos-una-mayuscula'),
      alMenosUnNumero: this._t.get('form.password.al-menos-un-número'),
      minimoCaracteres: this._t.get('form.password.minimo-caracteres'),
      maximoCaracteres: this._t.get('form.password.maximo-caracteres'),
      alMenosUnCaracterEspecial: this._t.get('form.password.al-menos-un-caracter-especial'),
      cambiarContrasena: this._t.get('form.password.cambiar-contrasena'),
      contrasenaCambiadaTitle: this._t.get('components.app-restablecer-password.contrasena-cambiada-title'),
      contrasenaCambiadaHtml: this._t.get('components.app-restablecer-password.contrasena-cambiada-html'),
      completeCampos: this._t.get('form.msg.complete-campos'),
      warnSummary: this._t.get('form.msg.warn-summary'),
    }));
    this.isCodigoValido()
  }

  configureForm() {
    this.form = this._fb.group({
      password: [null, [Validators.required, noWhitespaceValidator, Validators.pattern(PASSWORD_PATTERN), Validators.maxLength(200)]],
      passwordRepeat: [null, [Validators.required, noWhitespaceValidator]],
    }, { validators: this.passwordMatchValidator });
  }

  private passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    return control.value.password === control.value.passwordRepeat ? null : { notMatch: true };
  }

  onSubmit() {
    if (this.form.invalid) {
      Utils.markAllFormControlsAsTouched(this.form);
      this._ms.add({ severity: 'warn', summary: this.translations.warnSummary, detail: this.translations.completeCampos });
      return;
    }

    let request = {
      codigo: this._codigo,
      newPassword: this.form.get('password')?.value
    } as RestablecerPasswordRequest;
    this.restablecerPassword(request);
  }

  //#region API Calls
  isCodigoValido() {
    this._pu.isCodigoRestablecerPasswordValido(this._codigo).subscribe({
      next: (response: boolean) => {
         this.isCodeValid = response;
        if (response) {
          this.configureForm();
          return;
        }
        this.alertService.show({
          text: this.translations.codigoNoValido,
          icon: AlertIcon.WARN,
          showAccept: true,
           textAccept: this.translations.siguiente,
        }).subscribe(async (result:ResponseAlert) => {
           this._r.navigate(['/public/consulta']).then();
        });
      }
    });
  }

  restablecerPassword(request: RestablecerPasswordRequest) {
    this.loadingService.show();
    this._pu.restablecerPassword(request).subscribe({
      next: (response: string) => {
         this.alertService.show({
          title: this.translations.contrasenaCambiadaTitle,
          html: this.translations.contrasenaCambiadaHtml,
          icon: AlertIcon.SUCCESS,
          showAccept: true,
           textAccept: this.translations.siguiente,
        }).subscribe(async (result) => {
           this._r.navigate(['/public/consulta']).then();
        });
      }, error: ()=> this.loadingService.hide(),
      complete:()=> this.loadingService.hide(),
    });
  }
  //#endregion
}
